"use strict";
/*
 * Created on 12. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * PriceChangeReportDTO converter.
 *
 * @author SKu
 */


var PriceChangeReportDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceChangeReportDTOConverter, _DataObjectConverter_);

  function PriceChangeReportDTOConverter() {
    _classCallCheck(this, PriceChangeReportDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeReportDTOConverter).apply(this, arguments));
  }

  return PriceChangeReportDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceChangeReportDTOConverter = PriceChangeReportDTOConverter;